const Footer = () => {
    return ( 
        <>
            <footer>
                <h3>© 2021 - Present. All Rights Reserved.</h3>    
            </footer>
        </>
     );
}
 
export default Footer;